import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logger from "services/logger";

type AdminSubmit = {
  sending: boolean;

  /** Runs the mutation, redirects on success, logs + clears `sending` on failure. */
  submit: (run: () => Promise<unknown>) => Promise<void>;
};

/** Shared create/update submit handling for admin dashboard pages. */
export const useAdminSubmit = (redirectTo: string): AdminSubmit => {
  const navigate = useNavigate();
  const [sending, setSending] = useState(false);

  const submit = (run: () => Promise<unknown>): Promise<void> => {
    setSending(true);
    return run()
      .then(() => {
        navigate(redirectTo);
      })
      .catch((err) => {
        logger.sendError(err);
        setSending(false);
      });
  };

  return { sending, submit };
};
